import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const row: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  width: '100%',
  gap: (p) => p.spacing(1),
};

export const checkbox: SxStyle = {
  ml: 0,
  mr: 0,
  '& > span': {
    fontSize: (p) => `${p.typography.body4.fontSize}!important`,
    color: (p) => p.palette.grey[600],
  },
};

export const ownerContentPopup: SxStyle = {
  color: (p) => p.palette.grey[500],
  fontSize: (p) => p.typography.pxToRem(10),
};
